import { REACT_APP_API_BASE_URL } from '../state/configuration';
import axios, { AxiosInstance } from 'axios';
import { useSelector } from 'react-redux';
import { RootState } from '../state/store';

let onUnauthorized: (() => void) | null = null;

export function setUnauthorizedHandler(handler: () => void) {
  onUnauthorized = handler;
}

export const useCsrService = (): AxiosInstance => {
  const accessToken = useSelector((state: RootState) => {
    if (state.auth.auth && state.auth.auth.access) {
      return state.auth.auth.access.access;
    }

    return null;
  });

  // Create an instance with default configurations
  const instance = axios.create({
    baseURL: REACT_APP_API_BASE_URL || 'http://localhost:9000',
    timeout: 10000, // Set a timeout if needed
    headers: {
      'Content-Type': 'application/json',
      // Add any other default headers here
    },
  });

  // Add request interceptor to include token if available
  instance.interceptors.request.use(
    (config) => {
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  // Add response interceptor to handle responses globally
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      // Handle error responses (e.g., logging out on 401)
      if (
        (error.response && error.response.status === 401) ||
        error.response.status === 403
      ) {
        onUnauthorized?.();
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

export default useCsrService;
